import { Alert, AlertDescription, AlertTitle } from "ui/components/alert";

import { CIRCLE_CHECK_BIG } from "icons";
import { Icon } from "components";
import React from "react";

export default function ReviewSuccess({ isReviewed }) {
  if (isReviewed)
    return (
      <Alert className="max-w-80">
        <Icon icon={CIRCLE_CHECK_BIG} />
        <AlertTitle>Reviewed</AlertTitle>
        <AlertDescription>
          This log has been reviewed & can no longer be edited or deleted.
        </AlertDescription>
      </Alert>
    );

  return null;
}
